@use '@/styles/tokens' as *;

/* The whole cell is the tooltip trigger (ADO 119718) — a real button so it keeps the hover,
   focus and accessible name the `N+` badge used to carry on its own. */
.cell {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  max-width: 100%;
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
    border-radius: $radius-sm;
  }
}

.device {
  display: inline-flex;
  flex-direction: column;
}

.name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.coords {
  font-size: 12px;
  color: $color-neutral-600;
}

.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 var(--space-1);
  border: 0;
  border-radius: 50%;
  background: $color-neutral-900;
  color: $color-neutral-0; // palette is SCSS-var only, not a CSS custom prop
  font-size: 11px;
  flex: 0 0 auto;
}

/* Light tooltip content (Figma 8589:825488): device name (dark, medium) over labeled coords. */
.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  max-height: 260px;
  overflow-y: auto;
  padding: var(--space-2) var(--space-3);

  .name {
    font-size: 14px;
    font-weight: $font-weight-regular;
    color: $color-neutral-950;
  }

  .coords {
    font-size: 13px;
    color: $color-neutral-600;
  }
}
